import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  Chip,
  Breadcrumbs,
  Link,
  Button
} from '@mui/material';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import YouTubeIcon from '@mui/icons-material/YouTube';
import HelpTooltip from '../components/HelpTooltip';
import YoutubeSettings from '../components/YoutubeSettings';
import Toast from '../components/Toast';

export default function Worships() {
  const [loading, setLoading] = useState(true);
  const [biblestudy, setBiblestudy] = useState({});
  const [worship, setWorship] = useState({});
  const [selectedOrgId, setSelectedOrgId] = useState(null);
  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });

  const API_URL = process.env.REACT_APP_API_URL || 'http://45.194.3.128:4000/api/admin/';

  useEffect(() => {
    const rawUser = localStorage.getItem('userInfo');
    let effectiveOrgId = 1;
    if (rawUser) {
      try {
        const u = JSON.parse(rawUser);
        if (u?.org_id) effectiveOrgId = Number(u.org_id);
      } catch (e) {
        console.error(e);
      }
    }
    const currentOrg = localStorage.getItem('selectedOrgId') || effectiveOrgId;
    setSelectedOrgId(Number(currentOrg));
    fetchWorshipData(Number(currentOrg));
  }, []);

  const fetchWorshipData = async (orgId) => {
    setLoading(true);
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${API_URL}get-all-settings?org_id=${orgId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (response.ok && data) {
        setBiblestudy(data.bibleStudy?.[0] || {});
        setWorship(data.sundayWorships?.[0] || {});
      }
    } catch (err) {
      console.error('Error fetching worship data:', err);
      setToast({ open: true, message: 'Could not load worship settings', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: 1200, margin: '0 auto' }}>
      {/* Toast */}
      <Toast toast={toast} setToast={setToast} />

      {/* Breadcrumbs */}
      <Breadcrumbs sx={{ mb: 2 }}>
        <Link color="inherit" href="/admin/dashboard" underline="hover">
          Dashboard
        </Link>
        <Typography color="text.primary">Sunday Worship & Live Streaming</Typography>
      </Breadcrumbs>

      {/* Header Banner */}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          mb: 3,
        }}
      >
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <LiveTvIcon sx={{ fontSize: 32, color: '#DC2626' }} />
            <Typography variant="h5" fontWeight={700}>
              Sunday Worship & Bible Study
            </Typography>
            <HelpTooltip
              title="Sunday Worship & Live Broadcasts"
              purpose="Configure your ministry YouTube channel ID so church members can watch Sunday services and Bible study streams in the mobile app."
              howItWorks="Enter your channel name and channel ID. The mobile app automatically links and streams sermons."
              mobileEffect="Displays as the featured Worship and Message stream in the mobile app."
            />
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Manage YouTube channel IDs, live stream links, and Sunday service broadcasts.
          </Typography>
        </Box>

        <Chip
          icon={<YouTubeIcon sx={{ color: '#DC2626 !important' }} />}
          label="Live Streaming via YouTube"
          variant="outlined"
          sx={{ fontWeight: 600 }}
        />
      </Box>

      {/* Content Card */}
      <Card sx={{ borderRadius: 3, boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)' }}>
        <CardContent sx={{ p: { xs: 2, sm: 3.5 } }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
              <CircularProgress />
            </Box>
          ) : (
            <YoutubeSettings
              biblestudy={biblestudy}
              worship={worship}
              organization={selectedOrgId}
            />
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
